import {throwError as observableThrowError, of as observableOf,  Observable } from 'rxjs';
import {catchError,  map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';

import { Toc } from './../interfaces/toc';
import { AppHelperService } from './../../app/services/app-helper.service';
import { ActivityViewHelperService } from './activity-view-helper.service';

@Injectable()
export class ActivityViewDataService {

    constructor(
        private http: HttpClient,
        private apiGatewayHelperService: ApiGatewayHelperService,
        private appHelperService: AppHelperService,
        private activityViewHelperService: ActivityViewHelperService) { }

    //Temp Commenting cache code due to productive skill evaluation teacher updates

    //Get the shared class/product data (if not available fetch using API)
    /*getClassOrProductViewData(productId, classId?): Observable<any> {
        var cachedClassOrProductView;
        cachedClassOrProductView  = this.classOrProductViewCache.get('product' + ':' +  productId);

        if (cachedClassOrProductView) {
            // if `sharedClassProductViewData` is available just return it as `Observable`
            return Observable.of(cachedClassOrProductView);
        }
        return this.getClassActivityViewDataForLearner(productId, classId).share();
    }*/

    // Get Class/Product data from API
    /** 1. Class Product Scenario : Returns Class + Product Meta data and TOC
     *  2. Only Product Scenario : Returns Product Meta data and TOC
     *
     */

    /* Function to get class product data for learner */
    getClassActivityViewDataForLearner(spaceId, productCode, classId?, assignmentId?, folderId?): Observable<any> {
        const productViewData = this.activityViewHelperService.getProductViewData();
        if (productViewData) {
            return observableOf(productViewData);
        } else {
            let url = `${this.apiGatewayHelperService.getApiGatewayPrefixUrl()}${spaceId}/product/${productCode}`;
            if (classId) {
                url += '/' + classId;
                if (assignmentId) {
                    url += '/' + assignmentId;
                }
            }
            return this.http.get(url)
                .pipe(
                    map((res: any) => {
                        if (res.success === false && res.error === 'UA_NOT_PRESENT_ERROR') {
                            return res;
                        }
                        // traverse TOC one level from root and get the required folder's TOC
                        if (folderId) {
                            let folderToc = res.toc.result.filter((folder) => {
                                return folder['item-code'] == folderId;
                            })[0].items;
                            res.toc.result = folderToc
                        }
                        this.activityViewHelperService.setProductViewData(res);
                        return res;
                    }
                    )).pipe(catchError((error) => {
                        this.appHelperService.navigateToDashboardApp([]);
                        return observableThrowError(error);
                    }));
        }
    }

    /* Function to get class product data for teacher */
    getClassActivityViewDataForTeacher({ spaceId, productCode, classId, assignmentId = undefined }, assignmentDataRequired = false): Observable<any> {
        const productViewData = this.activityViewHelperService.getProductViewData();
        if (productViewData) {
            return observableOf(productViewData);
        } else {
            let url = `${this.apiGatewayHelperService.getApiGatewayPrefixUrl()}${spaceId}/teacher/product/${productCode}`;
            if (classId) {
                url += `/${classId}`;
            }
            if (assignmentId) {
                url += `/${assignmentId}`;
            }
            if (assignmentDataRequired) {
                url += `?assignmentDataRequired=true`;
            }
            return this.http.get(url).pipe(
                map((res: any) => {
                    this.activityViewHelperService.setProductViewData(res);
                    return res;
                }
                )).pipe(catchError((error) => {
                    this.appHelperService.navigateToDashboardApp([]);
                    return observableThrowError(error);
                }));
        }
    }

    //Store Product State (Last launched item)
    updateAppState(spaceId, productCode, appData, classId) {
        if (classId) {
            const isCBPClass = this.activityViewHelperService.getIsCBPClass();
            const isTestTypeProduct = this.activityViewHelperService.getIsTestTypeProduct();
            let url = this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/product/' + productCode + '/appstate/' + classId;

            if (isCBPClass) url += `?isCBPClass=${isCBPClass}`;
            if (isTestTypeProduct) url += `?isTestTypeProduct=${isTestTypeProduct}`;
            return this.http.put(url, appData);
        } else {
            return this.http.put(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/product/' + productCode + '/appstate', appData);
        }
    }

    getAnalyticsOfItem(spaceId, productCode, classId, itemId, groupId): Observable<any> {
        let url = this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/' + 'product/' + productCode + '/class/' + classId + '/item/' + itemId + '?history=true';
        if (groupId) {
            url = url + '&groupId=' + groupId;
        }
        return this.http.get(url).pipe(
            map(res => {
                return res;
            })
        )
    }
}
